import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=6b298c0c&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=ts&"
export * from "./Settings.vue?vue&type=script&lang=ts&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=6b298c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b298c0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b298c0c')) {
      api.createRecord('6b298c0c', component.options)
    } else {
      api.reload('6b298c0c', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=6b298c0c&scoped=true&", function () {
      api.rerender('6b298c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/Settings.vue"
export default component.exports